import { render, staticRenderFns } from "./SpvForm.vue?vue&type=template&id=71f4682a&lang=pug"
import script from "./SpvForm.vue?vue&type=script&lang=js"
export * from "./SpvForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports